/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react'
import {
  View,
  ScrollView,
  StatusBar,
  Platform,
  TouchableOpacity,
  Dimensions,
  ImageBackground,
  KeyboardAvoidingView,
  Image,
  BackHandler
} from 'react-native'
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context'
import PropTypes from 'prop-types'
// eslint-disable-next-line import/default
import ViewPager from 'react-native-pager-view'
// eslint-disable-next-line import/no-unresolved
import CheckBox from '@react-native-community/checkbox'
import { Icon, VFInput } from '@vfgroup-oneplatform/foundation/Components'
import { Colors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'
// eslint-disable-next-line import/named
import { selectContactPhone } from 'react-native-select-contact'
import {
  check,
  request,
  openSettings,
  PERMISSIONS,
  RESULTS
} from 'react-native-permissions'
import { RNCamera } from 'react-native-infy-camera'
// import ImageEditor from '@react-native-community/image-editor'
import { RNHoleView } from 'react-native-hole-view'
import moment from 'moment'

// eslint-disable-next-line import/no-named-as-default
import WebView from 'react-native-webview'
import ContentLoader, { Rect } from 'react-content-loader/native'

import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager'

import Timeline from '../../Components/Timeline'
import Card from '../../Components/Card'
import VfText from '../../Components/VfText'
import Collapsible from '../../Components/Collapsible'
import RowItem from '../../Components/RowItem'
import PreferenceItem from '../../Components/PreferenceItem'
import SelectGroup from '../../Components/SelectGroup'
import RadioGroup from '../../Components/RadioGroup'
import HorizontalLine from '../../Components/HorizontalLine'
import Modal from '../../Components/Modal'
import MigrationHeader from '../../Components/MigrationHeader'
import VFButton from '../../Components/VFButton'
import MigrationLottie from '../../Components/MigrationLottie'

import Countdown from '../../Components/Countdown/Countdown'

import images from '../../Themes/Images'

import _Modal from 'react-native-modal'

import styles, {
  timelineTitleProps,
  checkBoxTintcolors
} from './Migration.Styles'

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('window')

const MODAL_TYPES = {
  success: 'success',
  proccessing: 'proccesssing',
  error: 'error',
  idError: 'idError'
}

const INFO_MODAL_DETAILS = {
  id: {
    image: images.idCardExample,
    title: 'migration_id_helper_title',
    desc: 'migration_id_helper_info'
  },
  vatNumber: {
    image: images.vatNumberExample,
    title: 'migration_vat_number_helper_title',
    desc: 'migration_vat_number_helper_info'
  }
}

function OfferContent(props) {
  const {
    isOfferLoading,
    details,
    iconTypes,
    isContentLoading,
    extraBenefits
  } = props
  const theme = useTheme()

  return (
    <>
      <View style={styles.collapsedContent(theme)}>
        {isOfferLoading ? (
          <>
            <ContentLoader
              speed={2}
              width={'100%'}
              height={116}
              backgroundColor="#e4e4e4"
              foregroundColor="#d4d4d4">
              <Rect x="16" y="14" rx="6" ry="6" width="24" height="24" />
              <Rect x="50" y="19" rx="6" ry="6" width="110" height="20" />
              <Rect x="66" y="44" rx="6" ry="6" width="150" height="16" />
              <Rect x="66" y="66" rx="6" ry="6" width="180" height="16" />
              <Rect x="66" y="88" rx="6" ry="6" width="140" height="16" />
            </ContentLoader>

            <ContentLoader
              speed={2}
              width={'100%'}
              height={116}
              backgroundColor="#e4e4e4"
              foregroundColor="#d4d4d4">
              <Rect x="16" y="14" rx="6" ry="6" width="24" height="24" />
              <Rect x="50" y="19" rx="6" ry="6" width="110" height="20" />
              <Rect x="66" y="44" rx="6" ry="6" width="150" height="16" />
              <Rect x="66" y="66" rx="6" ry="6" width="180" height="16" />
              <Rect x="66" y="88" rx="6" ry="6" width="140" height="16" />
            </ContentLoader>
          </>
        ) : (
          details?.map((item, index) => (
            <RowItem
              key={index}
              icon={item.icon || iconTypes?.[item.type]}
              leftComponent={item.leftComponent}
              title={item.title}
              desc={item.desc}
              iconStyle={item.iconStyle}
              titleStyle={item.titleStyle}
              descStyle={item.descStyle}
              topText={item.topText}
              topContent={item.topContent}
              bottomText={item.bottomText}
              bottomContent={item.bottomContent}
            />
          ))
        )}
      </View>
      <View style={styles.extraListContainer}>
        <VfText
          size="h5"
          weight="bold"
          style={styles.extraTitle}
          isLoading={isContentLoading}
          i18nKey="migration_extra_benefits"
        />
        {isOfferLoading ? (
          <>
            <ContentLoader
              speed={2}
              width={'100%'}
              height={39}
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb">
              <Rect x="0" y="14" rx="6" ry="6" width="24" height="24" />
              <Rect x="34" y="19" rx="6" ry="6" width="210" height="20" />
            </ContentLoader>
            <ContentLoader
              speed={2}
              width={'100%'}
              height={39}
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb">
              <Rect x="0" y="14" rx="6" ry="6" width="24" height="24" />
              <Rect x="34" y="19" rx="6" ry="6" width="250" height="20" />
            </ContentLoader>
          </>
        ) : (
          extraBenefits?.map((item, index) => (
            <RowItem
              key={index}
              icon={item.icon || iconTypes?.[item.type]}
              title={item.title}
              desc={item.desc}
              iconStyle={styles.extraIconStyle}
              titleStyle={styles.extraTitleStyle}
              descStyle={item.descStyle}
            />
          ))
        )}
      </View>
    </>
  )
}
OfferContent.defaultProps = {
  isOfferLoading: false,
  details: [],
  iconTypes: {},
  isContentLoading: false,
  extraBenefits: []
}
OfferContent.propTypes = {
  isOfferLoading: PropTypes.bool,
  details: PropTypes.array,
  iconTypes: PropTypes.object,
  isContentLoading: PropTypes.bool,
  extraBenefits: PropTypes.array
}

function Migration(props) {
  const {
    isContentLoading,
    notify,
    existingOrder,
    type,
    offers,
    contractOptions,
    termsAndConditions,
    accountInfo,
    pin,
    verifyAccountInfo,
    createOrder,
    maxNumOfRetryConfirmation
  } = props

  const selectedOffer = offers?.data?.[offers.selectedOffer] || {}

  useEffect(() => {
    if (offers.selectedOffer === -1 && offers.data) {
      const i = offers.data?.findIndex(el => el.recomandation_type === '1')
      offers.setSelectedOffer(i)
    }
  }, [offers.data])

  const [confirmationCount, setConfirmationCount] = useState(0)
  const [isOfferLoading, setOfferLoading] = useState(true)
  const theme = useTheme()

  const getDetails = () => {
    setOfferLoading(true)
    offers.getOfferDetails({
      onSuccess: () => setOfferLoading(false),
      onError: error => {
        setModalState(state => {
          state.type = MODAL_TYPES.error
          state.title = 'migration_something_went_wrong'
          state.desc = `${error || ''}`
          state.backLabel = 'migration_close_modal'
          state.back = () => {
            getDetails()
            closeModal()
          }
          return state
        })
        openModal('full')
        setOfferLoading(false)
      }
    })
  }

  /** Get offer details */
  useEffect(() => {
    getDetails()
    termsAndConditions?.getPreferences?.({
      onSuccess: () => settermsLoading(false),
      onError: error => {
        settermsLoading(false)
        setModalState(state => {
          state.type = MODAL_TYPES.error
          state.title = 'migration_something_went_wrong'
          state.desc = `${error || ''}`
          state.backLabel = 'migration_close_modal'
          state.back = () => {
            confirmOfferSelection()
            closeModal()
          }
          return state
        })
        openModal()
      }
    })
  }, [type])

  const insets = useSafeAreaInsets()

  /** Information/Helper Modal */
  const [infoModal, setInfoModal] = useState({
    isOpen: false,
    type: 'normal',
    content: null
  })

  const openInfoModal = (content, modalType = 'normal', isOpen = true) => {
    setInfoModal({
      isOpen: isOpen,
      type: modalType,
      content: content
    })
  }

  const closeInfoModal = () =>
    setInfoModal({
      isOpen: false,
      content: null
    })

  /** Success and Error Modal */
  const [modalProps, setModalProps] = useState({
    isOpen: false,
    type: 'normal'
  })
  const [modalState, setModalState] = useState({
    loading: false,
    type: null,
    title: null,
    desc: null,
    backLabel: null,
    back: null,
    backLoading: false,
    retryLabel: null,
    retry: null,
    retryLoading: false
  })

  const openModal = (modalType = 'normal') => {
    setModalProps({
      isOpen: true,
      type: modalType
    })
  }

  const closeModal = () => {
    setModalState({
      loading: false,
      type: null,
      title: null,
      desc: null,
      backLabel: null,
      back: null,
      backLoading: false,
      retryLabel: null,
      retry: null,
      retryLoading: false
    })
    setModalProps({
      isOpen: false,
      type: 'normal'
    })
  }

  const iconTypes = {
    data: images.mobileData,
    internet: images.mobileData,
    sms: images.sms,
    smskomb: images.sms,
    smsvod: images.sms,
    min: images.phone,
    minkomb: images.phone,
    minnderkomb: images.phone,
    extra_benefits: images.tickConfirm,
    ...offers?.iconTypes
  }

  /** Viewpager reference to use @setPage function to change active page */
  const viewpagerRef = useRef(null)
  const [currentPageWeb, setCurrentPageWeb] = useState(1)

  /** Viewpager reference to use @setPage function to change active page on details verification step */
  const verificationPagesRef = useRef(null)
  const [currentVerificationPageWeb, setCurrentVerificationPageWeb] = useState(1)

  /** Progress array for the timeline on each page */
  const [progress, setProgress] = useState([
    {
      type: 'current',
      title: 'migration_step1_title'
    },
    {
      type: 'inactive',
      title: 'migration_step3_title'
    },
    {
      type: 'inactive',
      title: 'migration_step4_title'
    }
  ])

  const updateProgress = index => {
    setProgress(prev => {
      prev.map((_, i) => {
        let status = 'inactive'
        if (index - i > 0) {
          status = 'active'
        } else if (index - i === 0) {
          status = 'current'
        }
        prev[i].type = status
      })
      return [...prev]
    })
  }

  const timeline = () => (
    <View style={styles.timelineContainer(theme)}>
      <Timeline
        items={progress}
        direction="horizontal"
        titleStyle={styles.timelineItemTitle(theme)}
        titleProps={timelineTitleProps}
        activeTitleStyle={styles.timelineActiveItemTitle(theme)}
        iconContainerStyle={styles.timelineIconContainer}
        isContentLoading={isContentLoading}
      />
    </View>
  )

  /** Confirm offer selection */
  const [termsLoading, settermsLoading] = useState(false)

  const confirmOfferSelection = () => {
    if (termsAndConditions.acceptedRequired) {
      if (Platform.OS === 'web') {
        setCurrentPageWeb(2)
      } else {
        viewpagerRef?.current?.setPage(1)
      }
      updateProgress(1)
      notify(0)
    } else {
      settermsLoading(true)
      termsAndConditions?.updatePreferences({
        onSuccess: () => {
          viewpagerRef.current.setPage(1)
          updateProgress(1)
          settermsLoading(false)
          notify(0)
        },
        onError: error => {
          setModalState(state => {
            state.type = MODAL_TYPES.error
            state.title = 'migration_something_went_wrong'
            state.desc = `${error || ''}`
            state.backLabel = 'migration_close_modal'
            return state
          })
          openModal()
          settermsLoading(false)
        }
      })
    }

  }


  /** Search account */
  const [isIdError, setIdError] = useState(false)
  const checkIdNumber = () => {
    if (accountInfo?.idFormat) {
      if (!accountInfo.idFormat.test(accountInfo?.id)) {
        setIdError(true)
      }
    }
  }

  const [isVatNumberError, setVatNumberError] = useState(false)
  const checkVatNumber = () => {
    if (accountInfo?.vatNumberFormat) {
      if (
        accountInfo?.vatNumber &&
        !accountInfo.vatNumberFormat.test(accountInfo?.vatNumber)
      ) {
        setVatNumberError(true)
      }
    }
  }

  const [isEmailError, setEmailError] = useState(false)
  const checkEmail = () => {
    if (accountInfo?.emailFormat) {
      if (
        accountInfo?.email &&
        !accountInfo.emailFormat.test(accountInfo?.email)
      ) {
        setEmailError(true)
      }
    }
  }

  const [searchLoading, setSearchLoading] = useState(false)
  const searchAccount = () => {
    setSearchLoading(true)
    accountInfo?.searchAccount?.({
      onSuccess: () => {
        notify(2)
        if (Platform.OS === 'web') {
          setCurrentPageWeb(3)
        } else {
          viewpagerRef.current.setPage(2)
        }
        updateProgress(3)
        setSearchLoading(false)
      },
      onError: error => {
        setCurrentPageWeb(3)
        setModalState(state => {
          return {
            ...state,
            type: MODAL_TYPES.idError,
            title: 'migration_id_error_title',
            desc: 'migration_id_error_desc',
            backLabel: 'migration_reserve',
            back: () => {
              setModalState(prev => { return { ...prev, backLoading: true } })
              notify(5, {
                onSuccess: () => {
                  setModalState(prev => {
                    return {
                      ...prev,
                      type: MODAL_TYPES.proccessing,
                      title: 'migration_reservation_success_title',
                      desc: 'migration_reservation_success_desc',
                      backLabel: 'migration_back_to_dashboard',
                      back: () => {
                        closeModal()
                        closeScreen()
                      },
                      backLoading: false,
                      retryLabel: null,
                      retry: null
                    }
                  })
                },
                onError: e => {
                  setModalState(prev => {
                    return {
                      ...prev,
                      type: MODAL_TYPES.error,
                      title: 'migration_id_error_title',
                      desc: e.message,
                      backLabel: 'migration_back_to_dashboard',
                      back: () => {
                        closeModal()
                        closeScreen()
                      },
                      backLoading: false,
                      retryLabel: null,
                      retry: null
                    }
                  })
                }
              })
            },
            retryLabel: 'migration_try_again',
            retry: closeModal
          }
        })
        openModal('full')
        setSearchLoading(false)
      }
    })
  }
  /** Verify code reference */
  const verifyCodeInput = useRef(null)
  const [isConfirmPinDisabled, setIsConfirmPinDisabled] = useState(true)

  const [isResedLoading, setResendLoading] = useState(false)
  const requestPin = () => {
    if (Platform.OS === 'web') {
      setCurrentVerificationPageWeb(2)
    } else {
      verificationPagesRef.current.setPage(1)

    }
    if (pin?.numberOfRetries <= pin?.MAX_NUMBER_OF_RETRIES) {
      setResendLoading(true)
      pin?.setNumberOfRetries?.(pin?.numberOfRetries + 1)
      pin?.generatePin?.({
        onSuccess: () => setResendLoading(false),
        onError: error => {
          setModalState(state => {
            state.type = MODAL_TYPES.error
            state.title = 'migration_something_went_wrong'
            state.desc = `${error || ''}`
            state.backLabel = 'migration_close_modal'
            return state
          })
          openModal()
          setResendLoading(false)
        }
      })
    }
  }

  const [verifyCodeLoading, setVerifyCodeLoading] = useState(false)
  const verifyPinCode = () => {
    setVerifyCodeLoading(true)
    pin?.validatePin?.(verifyCodeInput.current?.state?.codeValue, {
      onSuccess: () => {
        setVerifyCodeLoading(false)
        if (Platform.OS === 'web') {
          setCurrentVerificationPageWeb(3)
        } else {
          verificationPagesRef.current.setPage(2)

        }
      },
      onError: error => {
        setModalState(state => {
          state.type = MODAL_TYPES.error
          state.title = 'migration_error_wrong_id'
          state.desc = `${error || ''}`
          state.backLabel = 'migration_close_modal'
          return state
        })
        openModal()
        setIsConfirmPinDisabled(true)
        verifyCodeInput.current.clear()
        setVerifyCodeLoading(false)
      }
    })
  }

  const renderModalContent = () => {
    let iconSize, icon
    if (modalProps.type === 'full') {
      iconSize = 95
      if (modalState.type === MODAL_TYPES.error) {
        icon = images.error
      } else if (modalState.type === MODAL_TYPES.proccessing) {
        icon = images.orderProcessing
      } else if (modalState.type === MODAL_TYPES.idError) {
        icon = images.idHIFI
      } else {
        icon = images.tick
      }
    } else {
      iconSize = 54
      if (modalState.type === MODAL_TYPES.error) {
        icon = images.warning
      } else if (modalState.type === MODAL_TYPES.proccessing) {
        icon = images.orderProcessing
      } else if (modalState.type === MODAL_TYPES.idError) {
        icon = images.idHIFI
      } else {
        icon = images.tick
      }
    }

    if (modalState.loading) {
      return null
    }
    if (!modalState.type) {
      return null
    }

    return (
      <View style={styles.modalContentContainerWraper(theme)}>
        <View style={styles.modalContentWraper2}>
          <Icon name={icon} size={iconSize} type="image" resizeMode="contain" />
          <VfText
            weight="bold"
            size="h2"
            align="center"
            style={styles.verticalSpacing}
            isLoading={isContentLoading}
            i18nKey={modalState.title}
          />
          <VfText
            align="center"
            size="h5"
            isLoading={isContentLoading}
            i18nKey={modalState.desc}
          />
        </View>
        <VFButton
          type="primary"
          title={modalState.backLabel || 'migration_close_modal'}
          onPress={() => modalState.back ? modalState.back() : closeModal()}
          disabled={modalState.backLoading || modalState.retryLoading}
          isLoading={modalState.backLoading}
          loadingTitle="migration_processing_action"
        />
        {modalState.retry && (
          <VFButton
            type="secondary"
            title={modalState.retryLabel || 'migration_try_again'}
            onPress={modalState.retry}
            style={styles.secondaryButton}
            disabled={modalState.backLoading || modalState.retryLoading}
            isLoading={modalState.retryLoading}
            loadingTitle="migration_processing_action"
          />
        )}
      </View>
    )
  }

  const findIdContent = (contentType = 'id') => {
    const { image, title, desc } = INFO_MODAL_DETAILS[contentType]

    return (
      <View style={styles.modalContentContainerWraper(theme)}>
        <View style={styles.modalContentWraper}>
          <Icon
            name={image}
            size={200}
            type="image"
            resizeMode="contain"
          />
          <VfText
            weight="bold"
            size="h1"
            align="center"
            style={styles.verticalSpacing}
            isLoading={isContentLoading}
            i18nKey={title}
          />
          <VfText
            align="center"
            size="h5"
            isLoading={isContentLoading}
            i18nKey={desc}
          />
        </View>
        <VFButton
          type="primary"
          title="migration_close_modal"
          onPress={closeInfoModal}
        />
      </View>
    )
  }

  //Verify account details
  const [isRechargeValueError, setRechargeValueError] = useState(false)

  const saveRechargeValue = () => {
    if (
      !verifyAccountInfo?.lastRecharge ||
      verifyAccountInfo?.lastRecharge === ''
    ) {
      return
    }

    if (verifyAccountInfo?.lastRechargeFormat) {
      if (
        !verifyAccountInfo.lastRechargeFormat.test(
          verifyAccountInfo?.lastRecharge,
        )
      ) {
        setRechargeValueError(true)
        return
      } else {
        const value = Number(verifyAccountInfo?.lastRecharge)
        if (
          value < verifyAccountInfo?.minRecharge ||
          value > verifyAccountInfo?.maxRecharge
        ) {
          setRechargeValueError(true)
          return
        }
      }
    }

    verifyAccountInfo?.addToLastRecharge?.()
  }

  const [isContactError, setContactError] = useState(false)
  const saveContact = number => {
    if (!number && !verifyAccountInfo?.mostCalledNumber) {
      return
    }
    if (verifyAccountInfo?.mostCalledNumberFormat) {
      if (
        !verifyAccountInfo.mostCalledNumberFormat.test(
          number || verifyAccountInfo?.mostCalledNumber,
        )
      ) {
        setContactError(true)
        return
      }
    }
    verifyAccountInfo?.addToMostCalled?.(number)
  }

  // Select Contact
  const selectContact = () => {
    check(
      Platform.OS === 'android'
        ? PERMISSIONS.ANDROID.READ_CONTACTS
        : PERMISSIONS.IOS.CONTACTS,
    )
      .then(result => {
        switch (result) {
          case RESULTS.UNAVAILABLE:
            break
          case RESULTS.DENIED:
            request(
              Platform.select({
                android: PERMISSIONS.ANDROID.READ_CONTACTS,
                ios: PERMISSIONS.IOS.CONTACTS
              }),
            )
            break
          case RESULTS.GRANTED:
            return selectContactPhone().then(selection => {
              if (!selection) {
                return
              }
              saveContact(selection.selectedPhone?.number)
              return
            })
          case RESULTS.BLOCKED:
            openSettings().catch(() => null)
            break
        }
      })
      .catch(() => null)
  }

  const [isNameError, setNameError] = useState(false)
  const checkName = () => {
    if (verifyAccountInfo?.nameFormat) {
      if (!verifyAccountInfo.nameFormat.test(verifyAccountInfo?.name)) {
        setNameError(true)
      }
    }
  }
  const [isSurnameError, setSurnameError] = useState(false)
  const checkSurname = () => {
    if (verifyAccountInfo?.surnameFormat) {
      if (!verifyAccountInfo.surnameFormat.test(verifyAccountInfo?.surname)) {
        setSurnameError(true)
      }
    }
  }
  const [isAddressError, setAddressError] = useState(false)
  const checkAddress = () => {
    if (verifyAccountInfo?.addressFormat) {
      if (!verifyAccountInfo.addressFormat.test(verifyAccountInfo?.address)) {
        setAddressError(true)
      }
    }
  }
  const [isEmailAddressError, setEmailAddressError] = useState(false)
  const checkEmailAddress = () => {
    if (accountInfo?.emailFormat) {
      if (
        verifyAccountInfo?.emailAddress &&
        !accountInfo.emailFormat.test(verifyAccountInfo?.emailAddress)
      ) {
        setEmailAddressError(true)
      }
    }
  }
  const [isContactNumberError, setContactNumberError] = useState(false)
  const checkContactNumber = () => {
    if (verifyAccountInfo?.numberFormat) {
      if (
        !verifyAccountInfo.numberFormat.test(verifyAccountInfo?.contactNumber)
      ) {
        setContactNumberError(true)
      }
    }
  }

  /** Camera related states and functions */
  const [isCameraOpen, setIsCameraOpen] = useState(false)
  const [scanning, setScanning] = useState(false)

  const cameraHelperText = {
    scanning_false: 'migration_scan_id_instructions',
    scanning_true: 'migration_scaning_id'
  }
  const scannedImageText = {
    disabled_true: {
      title: 'migration_scanned_image_title',
      color: Colors.thinDark,
      backgroundColor: Colors.activeGrey
    },
    disabled_false: {
      title: 'migration_remove_photo',
      color: Colors.white,
      backgroundColor: Colors.blackRGBA(0.2)
    }
  }

  const [imageWidth] = useState(SCREEN_WIDTH - 32)
  const [imageHeight] = useState(imageWidth / 1.582)
  const [modalSize, setModalSize] = useState(SCREEN_HEIGHT - 32)
  const [cameraControlSize, setCameraControllSize] = useState(150)

  const verticalCropPosition =
    (modalSize - cameraControlSize - imageHeight) / 2

  const getModalDimensions = dimensions => {
    setModalSize(dimensions.height)
  }

  const getDimensions = dimensions => {
    setCameraControllSize(dimensions.height)
  }

  const camera = useRef(null)

  const takePicture = () => {
    if (camera.current) {
      setScanning(true)

      const options = {
        width: SCREEN_WIDTH * 2,
        height: (modalSize - cameraControlSize) * 2,
        quality: 1,
        base64: true,
        skipProcessing: true,
        fixOrientation: true,
        forceUpOrientation: true,
        pauseAfterCapture: true,
        orientation: 'portrait'
      }

      camera.current
        .takePictureAsync(options)
        .then(data => {
          verifyAccountInfo?.setImageFile?.(data)
        })
        .then(() => {
          setIsCameraOpen(false)
          setScanning(false)
        })
    }
  }

  const removePhoto = () => {
    verifyAccountInfo?.setImageFile?.(null)
  }

  function getCamera() {
    return (
      <View style={styles.cameraContainer}>
        <RNCamera
          ref={ref => {
            camera.current = ref
          }}
          style={styles.camera}
          type={RNCamera.Constants.Type.back}
          flashMode={RNCamera.Constants.FlashMode.auto}
          focusable
          useNativeZoom
          captureAudio={false}>
          <View pointerEvents="none" style={styles.cameraContainer}>
            <RNHoleView
              style={styles.overlayMask}
              holes={[
                {
                  x: 16,
                  y: verticalCropPosition,
                  width: imageWidth,
                  height: imageHeight,
                  borderRadius: 10
                }
              ]}
            />
          </View>
          <View
            pointerEvents="none"
            style={[
              styles.overlayMaskOutline,
              {
                top: verticalCropPosition,
                width: imageWidth,
                height: imageHeight
              }
            ]}
          />
        </RNCamera>
        <View
          onLayout={event => getDimensions(event.nativeEvent.layout)}
          style={styles.cameraControlContainer}>
          <View style={styles.cameraControlHeader}>
            <VfText
              size="h5"
              weight="bold"
              isLoading={isContentLoading}
              i18nKey="migration_scan_id_title"
            />
            <TouchableOpacity onPress={() => setIsCameraOpen(false)}>
              <Icon
                source={images.close}
                size={20}
                type="image"
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
          <VfText
            style={styles.textSpacing}
            isLoading={isContentLoading}
            i18nKey={cameraHelperText[`scanning_${scanning}`]}
          />
          <TouchableOpacity
            onPress={takePicture}
            disabled={scanning}
            style={styles.takePictureContainer}>
            <View style={styles.takePictureOuter}>
              <View style={styles.takePictureInner} />
            </View>
          </TouchableOpacity>
        </View>
      </View>
    )
  }

  const [isTermsVisible, setTermsVisible] = useState(false)

  function getTermsAndContidions() {
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <View style={{
          height: '85%',
          minWidth: '600px',
          maxWidth: '600px',
          backgroundColor: theme.colors.quickActionGradientColors.secondary,
          margin: 'auto',
          padding: '20px',
          borderRadius: "7px",
        }}>
          <View style={[styles.modalHeaderContainer, { marginTop: 0 }]}>
            <VfText i18nKey="migration_terms_section_title" size="h3" weight="bold" style={styles.fill} />
            <TouchableOpacity onPress={() => setTermsVisible(false)}>
              <Icon name={images.close} type="image" size={24} resizeMode="contain" />
            </TouchableOpacity>
          </View>

          <ScrollView
            key="2"
            style={styles.full}
            contentContainerStyle={styles.scrollContainerWithSpace(insets.bottom, theme)}
            showsVerticalScrollIndicator={false}
          >
            <View style={styles.collapsedContent2} onStartShouldSetResponderCapture={() => true}>
              {termsAndConditions?.loading ? (
                <>
                  <View style={styles.termsRowStyle}>
                    <ContentLoader
                      speed={2}
                      width={'100%'}
                      height={110}
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb">
                      <Rect
                        x="0"
                        y="3"
                        rx="6"
                        ry="6"
                        width="280"
                        height="16"
                      />
                      <Rect
                        x="0"
                        y="25"
                        rx="6"
                        ry="6"
                        width="210"
                        height="16"
                      />
                      <Rect
                        x="0"
                        y="47"
                        rx="6"
                        ry="6"
                        width="290"
                        height="16"
                      />
                      <Rect
                        x="0"
                        y="69"
                        rx="6"
                        ry="6"
                        width="180"
                        height="16"
                      />
                      <Rect
                        x="0"
                        y="91"
                        rx="6"
                        ry="6"
                        width="230"
                        height="16"
                      />
                    </ContentLoader>
                    <ContentLoader
                      speed={2}
                      width={'100%'}
                      height={28}
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb">
                      <Rect
                        x="16"
                        y="8"
                        rx="6"
                        ry="6"
                        width="20"
                        height="20"
                      />
                      <Rect
                        x="42"
                        y="10"
                        rx="6"
                        ry="6"
                        width="280"
                        height="16"
                      />
                    </ContentLoader>
                  </View>
                  <View style={styles.termsRowStyle}>
                    <ContentLoader
                      speed={2}
                      width={'100%'}
                      height={110}
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb">
                      <Rect
                        x="0"
                        y="3"
                        rx="6"
                        ry="6"
                        width="190"
                        height="16"
                      />
                      <Rect
                        x="0"
                        y="25"
                        rx="6"
                        ry="6"
                        width="220"
                        height="16"
                      />
                      <Rect
                        x="0"
                        y="47"
                        rx="6"
                        ry="6"
                        width="250"
                        height="16"
                      />
                      <Rect
                        x="0"
                        y="69"
                        rx="6"
                        ry="6"
                        width="210"
                        height="16"
                      />
                      <Rect
                        x="0"
                        y="91"
                        rx="6"
                        ry="6"
                        width="260"
                        height="16"
                      />
                    </ContentLoader>
                    <ContentLoader
                      speed={2}
                      width={'100%'}
                      height={28}
                      backgroundColor="#f3f3f3"
                      foregroundColor="#ecebeb">
                      <Rect
                        x="16"
                        y="8"
                        rx="6"
                        ry="6"
                        width="20"
                        height="20"
                      />
                      <Rect
                        x="42"
                        y="10"
                        rx="6"
                        ry="6"
                        width="280"
                        height="16"
                      />
                    </ContentLoader>
                  </View>
                </>
              ) : (
                termsAndConditions?.content?.map((item, index) => (
                  <PreferenceItem
                    key={index}
                    id={item.id}
                    necessity={item.necessity}
                    withCheckBox={item.withCheckBox}
                    value={item.value}
                    onValueChange={(id, value) =>
                      termsAndConditions?.updatePreference?.(
                        id,
                        value,
                      )
                    }
                    label={item.label}
                    labelPlaceholders={item.labelPlaceholders}
                    labelStyle={item.labelStyle}
                    desc={item.desc}
                    descPlaceholders={item.descPlaceholders}
                    descStyle={item.descStyle}
                    style={styles.termsRowStyle}
                  />
                ))
              )}
            </View>
          </ScrollView>
        </View>
      )
    }
    return (
      <>
        <View style={styles.modalHeaderContainer}>
          <VfText i18nKey="migration_terms_section_title" size="h3" weight="bold" style={styles.fill} />
          <TouchableOpacity onPress={() => setTermsVisible(false)}>
            <Icon name={images.close} type="image" size={24} resizeMode="contain" />
          </TouchableOpacity>
        </View>
        <ScrollView
          key="2"
          style={styles.full}
          contentContainerStyle={styles.scrollContainerWithSpace(insets.bottom, theme)}
          showsVerticalScrollIndicator={false}
        >
          <View style={styles.collapsedContent2} onStartShouldSetResponderCapture={() => true}>
            {termsAndConditions?.loading ? (
              <>
                <View style={styles.termsRowStyle}>
                  <ContentLoader
                    speed={2}
                    width={'100%'}
                    height={110}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb">
                    <Rect
                      x="0"
                      y="3"
                      rx="6"
                      ry="6"
                      width="280"
                      height="16"
                    />
                    <Rect
                      x="0"
                      y="25"
                      rx="6"
                      ry="6"
                      width="210"
                      height="16"
                    />
                    <Rect
                      x="0"
                      y="47"
                      rx="6"
                      ry="6"
                      width="290"
                      height="16"
                    />
                    <Rect
                      x="0"
                      y="69"
                      rx="6"
                      ry="6"
                      width="180"
                      height="16"
                    />
                    <Rect
                      x="0"
                      y="91"
                      rx="6"
                      ry="6"
                      width="230"
                      height="16"
                    />
                  </ContentLoader>
                  <ContentLoader
                    speed={2}
                    width={'100%'}
                    height={28}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb">
                    <Rect
                      x="16"
                      y="8"
                      rx="6"
                      ry="6"
                      width="20"
                      height="20"
                    />
                    <Rect
                      x="42"
                      y="10"
                      rx="6"
                      ry="6"
                      width="280"
                      height="16"
                    />
                  </ContentLoader>
                </View>
                <View style={styles.termsRowStyle}>
                  <ContentLoader
                    speed={2}
                    width={'100%'}
                    height={110}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb">
                    <Rect
                      x="0"
                      y="3"
                      rx="6"
                      ry="6"
                      width="190"
                      height="16"
                    />
                    <Rect
                      x="0"
                      y="25"
                      rx="6"
                      ry="6"
                      width="220"
                      height="16"
                    />
                    <Rect
                      x="0"
                      y="47"
                      rx="6"
                      ry="6"
                      width="250"
                      height="16"
                    />
                    <Rect
                      x="0"
                      y="69"
                      rx="6"
                      ry="6"
                      width="210"
                      height="16"
                    />
                    <Rect
                      x="0"
                      y="91"
                      rx="6"
                      ry="6"
                      width="260"
                      height="16"
                    />
                  </ContentLoader>
                  <ContentLoader
                    speed={2}
                    width={'100%'}
                    height={28}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb">
                    <Rect
                      x="16"
                      y="8"
                      rx="6"
                      ry="6"
                      width="20"
                      height="20"
                    />
                    <Rect
                      x="42"
                      y="10"
                      rx="6"
                      ry="6"
                      width="280"
                      height="16"
                    />
                  </ContentLoader>
                </View>
              </>
            ) : (
              termsAndConditions?.content?.map((item, index) => (
                <PreferenceItem
                  key={index}
                  id={item.id}
                  necessity={item.necessity}
                  withCheckBox={item.withCheckBox}
                  value={item.value}
                  onValueChange={(id, value) =>
                    termsAndConditions?.updatePreference?.(
                      id,
                      value,
                    )
                  }
                  label={item.label}
                  labelPlaceholders={item.labelPlaceholders}
                  labelStyle={item.labelStyle}
                  desc={item.desc}
                  descPlaceholders={item.descPlaceholders}
                  descStyle={item.descStyle}
                  style={styles.termsRowStyle}
                />
              ))
            )}
          </View>
          <View style={styles.collapsedContent2}>
            <VFButton
              type="primary"
              title='migration_save_button'
              style={{ marginTop: 10 }}
              disabled={termsLoading}
              onPress={() => {
                settermsLoading(true)
                setTermsVisible(false)
                termsAndConditions?.updatePreferences({
                  onSuccess: () => {
                    settermsLoading(false)
                  },
                  onError: error => {
                    setModalState(state => {
                      state.type = MODAL_TYPES.error
                      state.title = 'migration_something_went_wrong'
                      state.desc = `${error || ''}`
                      state.backLabel = 'migration_close_modal'
                      return state
                    })
                    openModal()
                    settermsLoading(false)
                  }
                })
              }}
            />
          </View>
        </ScrollView>
      </>
    )
  }

  useEffect(() => {
    if (existingOrder) {
      setModalState(state => {
        state.type = MODAL_TYPES.proccessing
        state.title = 'migration_existing_order_processing'
        state.desc = 'migration_existing_order_message'
        state.backLabel = 'migration_back_to_dashboard'
        state.back = () => {
          closeModal()
          closeScreen()
        }
        return state
      })
      openModal('full')
    }
  }, [existingOrder])

  const [orderCreationLoading, setOrderCreationLoading] = useState(false)
  const CreateOrder = () => {
    setOrderCreationLoading(true)
    setConfirmationCount(prev => prev + 1)
    notify(3)
    createOrder?.(verifyCodeInput.current?.state?.codeValue, {
      onSuccess: () => {
        setModalState(state => {
          state.type = MODAL_TYPES.success
          state.title = 'migration_success'
          state.desc = 'migration_congratulation_message'
          state.backLabel = 'migration_close_modal'
          state.back = () => {
            closeModal()
            closeScreen()
          }
          return state
        })
        openModal('full')
        setOrderCreationLoading(false)
      },
      onError: error => {
        setModalState(state => {
          state.type = MODAL_TYPES.error
          state.title = 'migration_oops_problem'
          state.desc = `${error || ''}`
          state.backLabel = 'migration_close_modal'
          return state
        })
        openModal('full')
        setOrderCreationLoading(false)
      }
    })
  }

  /** Ofer dettails */
  const offerDetailsContent = () => {

    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <View style={{
          height: 'auto',
          minWidth: '600px',
          maxWidth: '600px',
          backgroundColor: theme.colors.backgroundColor,
          margin: 'auto',
          padding: '20px',
          borderRadius: "7px",
        }}>
          <View style={styles.offerDetailsContent}>
            <VfText
              size="h3"
              weight="bold"
              isLoading={isContentLoading}
              i18nKey="migration_details_title"
              color={Colors.dark_grey}
            />
            <TouchableOpacity onPress={() => closeInfoModal()}>
              <Icon
                source={images.close}
                size={20}
                type="image"
                resizeMode="contain"
                style={{
                  tintColor: Colors.thinDark
                }}
              />
            </TouchableOpacity>
          </View>
          <View
            style={{ height: SCREEN_HEIGHT / 1.75 }}
            onStartShouldSetResponder={() => true}>
            <WebView
              source={{ uri: selectedOffer.details_link || ContentManager.translate('migration_details_link') }}
              style={[
                styles.webView,
                Platform.select({
                  web: {
                    minHeight: 0
                  },
                  default: {
                  }
                })
              ]}
              startInLoadingState={true}
              renderLoading={() => (
                <View style={styles.lottieWrapper}>
                  <MigrationLottie
                    source={require('./loaderE60000.json')}
                    style={styles.lottie}
                  />
                </View>
              )}
            />
          </View>
          <VFButton
            type="primary"
            title="migration_close_modal"
            onPress={() => closeInfoModal()}
            style={[styles.button, { marginHorizontal: 0 }]}
          />
          {/* <TouchableOpacity onPress={() => closeInfoModal()}>
            <Icon
              source={images.close}
              size={20}
              type="image"
              resizeMode="contain"
              style={{
                tintColor: Colors.thinDark
              }} />
          </TouchableOpacity> */}
        </View >
      )
    }
    return (
      <View style={styles.offerDetailsContainer}>
        <View style={styles.offerDetailsContent}>
          <VfText
            size="h3"
            weight="bold"
            color={Colors.dark_grey}
            isLoading={isContentLoading}
            i18nKey="migration_details_title"
          />
          <TouchableOpacity onPress={() => closeInfoModal()}>
            <Icon
              source={images.close}
              size={20}
              type="image"
              resizeMode="contain"
              style={{
                tintColor: Colors.thinDark
              }}
            />
          </TouchableOpacity>
        </View>
        <View
          style={{ height: SCREEN_HEIGHT / 1.75 }}
          onStartShouldSetResponder={() => true}>
          <WebView
            source={{ uri: selectedOffer.details_link || ContentManager.translate('migration_details_link') }}
            style={styles.webView}
            startInLoadingState={true}
            renderLoading={() => (
              <View style={styles.lottieWrapper}>
                <MigrationLottie
                  source={require('./loaderE60000.json')}
                  style={styles.lottie}
                />
              </View>
            )}
          />
        </View>
        <VFButton
          type="primary"
          title="migration_close_modal"
          onPress={() => closeInfoModal()}
          style={styles.button}
        />
      </View>
    )
  }

  const header = (
    <MigrationHeader
      title="migration_title"
      rightIcon={images.close}
      onRightPress={() => closeScreen()}
      isContentLoading={isContentLoading}
      loadingBackgroundColor={Colors.red}
      loadingForegroundColor={Colors.white}>

      <View style={styles.headerContentContainer}>
        <View style={styles.fillRemainingSpace}>
          <Countdown to={selectedOffer.expirationDate} format="YYYYMMDDTHHmmss.SSS Z" />
          <VfText
            color={Colors.white}
            isLoading={isContentLoading}
            loadingBackgroundColor={Colors.red}
            loadingForegroundColor={Colors.white}
            i18nKey="migration_label_from_offer_end"
            numberOfLines={2}
            style={styles.headerOfferTitle}
          />
        </View>
        {/* <View style={styles.fillRemainingSpace}>
          {isOfferLoading ? (
            <ContentLoader
              speed={1}
              width={196}
              height={60}
              backgroundColor={Colors.red}
              foregroundColor={Colors.white}>
              <Rect x="16" y="5" rx="6" ry="6" width="180" height="20" />
              <Rect x="16" y="33" rx="6" ry="6" width="140" height="20" />
            </ContentLoader>
          ) : (
              <>
                <VfText
                  size="h3"
                  color={Colors.white}
                  isLoading={isContentLoading}
                  loadingBackgroundColor={Colors.red}
                  loadingForegroundColor={Colors.white}
                  i18nKey={selectedOffer.title || ''}
                  style={styles.headerOfferTitle}
                />
                <VfText
                  size="h3"
                  weight="bold"
                  color={Colors.white}
                  isLoading={isContentLoading}
                  loadingBackgroundColor={Colors.red}
                  loadingForegroundColor={Colors.white}
                  i18nKey={selectedOffer.price?.discounted_price?.title || ''}
                  style={styles.headerOfferTitle}
                />
              </>
            )}
        </View> */}
        <TouchableOpacity
          style={styles.row}
          onPress={() => openInfoModal(offerDetailsContent)}
          activeOpacity={0.5}>
          <VfText
            size="footnote"
            color={Colors.white}
            isLoading={isContentLoading}
            loadingBackgroundColor={Colors.red}
            loadingForegroundColor={Colors.white}
            i18nKey="migration_view_details"
          />
          <Icon
            source={images.bulletList}
            size={20}
            type="image"
            resizeMode="contain"
            style={styles.headerIcon}
          />
        </TouchableOpacity>
      </View>
      <VfText
        color={Colors.white}
        isLoading={isContentLoading}
        loadingBackgroundColor={Colors.red}
        loadingForegroundColor={Colors.white}
        i18nKey="migration_info"
        style={styles.textSpacing}
      />
    </MigrationHeader>
  )

  const closeScreen = () => {
    props.onClose()
  }

  const renderModalInfo = () => {
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <_Modal
          isVisible={infoModal.isOpen}
          backdropOpacity={0.5}
          onSwipeComplete={() => closeInfoModal()}
          onBackdropPress={() => closeInfoModal()}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          {infoModal.content?.()}
        </_Modal>
      )
    }
    return (
      <Modal
        visible={infoModal.isOpen}
        close={() => closeInfoModal()}
        type={infoModal.type}
        contentContainerStyle={styles.modal}
        insets={insets}>
        {infoModal.content?.()}
      </Modal>
    )
  }

  const renderGetTerms = () => {
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      return (
        <_Modal
          isVisible={isTermsVisible}
          backdropOpacity={0.5}
          onSwipeComplete={() => setTermsVisible(false)}
          onBackdropPress={() => setTermsVisible(false)}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          {getTermsAndContidions()}
        </_Modal>
      )
    } else {
      return (
        <Modal
          visible={isTermsVisible}
          close={() => setTermsVisible(false)}
          type={'full'}
          contentContainerStyle={styles.termsModal}
          insets={insets}>
          {getTermsAndContidions()}
        </Modal>
      )
    }
  }

  const [stepId, setStepId] = useState(0)

  const renderContainer = () => {

    if (currentPageWeb === 1) {
      return (
        <View
          key="1"
          contentContainerStyle={styles.scrollContainer(insets.bottom, theme)}
          showsVerticalScrollIndicator={false}>
          <Collapsible
            items={offers.data?.map(offer => ({
              icon: images.sim,
              title: offer?.title || '',
              desc: offer?.price?.discounted_price?.title || '',
              content: (
                <OfferContent
                  isOfferLoading={isOfferLoading}
                  details={offer?.lineItem}
                  iconTypes={iconTypes}
                  isContentLoading={isContentLoading}
                  extraBenefits={offer?.extraBenefits}

                />
              ),
              isOpend: true,
              isLoading: isOfferLoading,
              card: {
                shadowLevel: 'high',
                title: offer?.recomandation_type === '1' ? 'migration_offer_type' : undefined
              }
            }))}
            titleStyle={styles.titleStyle(theme)}
            descStyle={styles.titleStyle(theme)}
            isContentLoading={isContentLoading}
            selected={offers.selectedOffer}
            setSelected={offers?.setSelectedOffer}
            withCard
          />
          <VfText
            size="h3"
            style={styles.sectionTitle}
            isLoading={isContentLoading}
            i18nKey="migration_contract_section_title"
          />
          <SelectGroup
            options={selectedOffer.activationPeriod}
            selected={offers?.selectedPeriod}
            setSelected={offers?.setSelectedPeriod}
            style={styles.options}
            isLoading={isOfferLoading}
          />
          <View style={styles.toggleAllContainer}>
            {termsAndConditions?.loading ? (
              <ContentLoader
                speed={2}
                width={'100%'}
                height={32}
                backgroundColor="#e4e4e4"
                foregroundColor="#d4d4d4">
                <Rect x="8" y="6" rx="3" ry="3" width="19" height="19" />
                <Rect x="34" y="10" rx="3" ry="3" width="280" height="12" />
              </ContentLoader>
            ) : (
              <>
                <CheckBox
                  value={termsAndConditions?.toggleAll}
                  onValueChange={newValue =>
                    termsAndConditions?.updateAllPreferences?.(newValue)
                  }
                  disabled={false}
                  tintColors={checkBoxTintcolors}
                  boxType="square"
                  tintColor={Colors.veryLightPinkTwo}
                  onTintColor={Colors.white}
                  onCheckColor={Colors.white}
                  onFillColor={Colors.ocean}
                  onAnimationType="bounce"
                  offAnimationType="bounce"
                  style={{
                    ...Platform.select({
                      ios: styles.iosCheckBoxStyle
                    })
                  }}
                />
                <TouchableOpacity onPress={() => setTermsVisible(true)} style={styles.viewTermsLink}>
                  <VfText i18nKey="migration_terms_agree_all" color={theme.colors.textColorTwo} numberOfLines={2} style={styles.viewTermsText} />
                </TouchableOpacity>
              </>
            )}
          </View>
          <VfText
            size="footnote"
            align="center"
            color={theme.colors.textColorTwo}
            isLoading={isContentLoading}
            i18nKey="migration_terms_accept_info"
            style={styles.bottomText}
          />
          <VFButton
            type="primary"
            title="migration_contract_confirm"
            onPress={confirmOfferSelection}
            style={styles.lastButton}
            disabled={offers.isNextDisabled}
            isLoading={termsLoading}
            loadingTitle="migration_processing_action"
          />
        </View>
      )
    }

    if (currentPageWeb === 2) {
      return (
        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          keyboardVerticalOffset={Platform.OS === 'ios' ? (insets.top + insets.bottom) : 0}
          focusable
          style={styles.container}>
          <ScrollView
            key="3-1"
            contentContainerStyle={styles.scrollContainer(insets.bottom, theme)}
            showsVerticalScrollIndicator={false}>
            <VfText
              size="h3"
              weight="bold"
              style={styles.sectionTitle}
              isLoading={isContentLoading}
              i18nKey="migration_account_section_title"
            />
            <VfText
              style={styles.textSpacing}
              isLoading={isContentLoading}
              i18nKey="migration_account_section_info"
            />
            <Card
              shadowLevel="low"
              style={styles.cardStyle}
              contentContainerStyle={styles.cardContentContaoner3}>
              <VFInput
                label="migration_id_placeholder"
                showRightIcon
                rightIconName={images.info_black}
                rightIconType="image"
                rightIconPress={() =>
                  openInfoModal(findIdContent, 'full')
                }
                value={accountInfo?.id}
                onChangeText={text => accountInfo?.setIdNumber(text)}
                containerStyle={styles.inputContainer}

                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                onBlur={checkIdNumber}
                onFocus={() => setIdError(false)}
                showHelperText={isIdError}
                helperText="migration_wrong_id_format"
                onContentSizeChange={() => { }}
                autoCapitalize='characters'
              />
              <VFInput
                label="migration_email_placeholder"
                value={accountInfo?.email}
                onChangeText={text => accountInfo?.setEmail(text)}
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText}
                style={styles.inputText}
                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                keyboardType="email-address"
                onBlur={checkEmail}
                onFocus={() => setEmailError(false)}
                showHelperText={isEmailError}
                helperText="migration_wrong_email_format"
                autoCapitalize='none'
              />
              {accountInfo?.selectedAccountType === 1 && <VFInput
                label="migration_vat_number_placeholder" showRightIcon
                rightIconName={images.info_black}
                rightIconType="image"
                rightIconPress={() =>
                  openInfoModal(() => findIdContent('vatNumber'), 'full')
                }
                value={accountInfo?.vatNumber}
                onChangeText={text => accountInfo?.setVatNumber(text)}
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText}
                style={styles.inputText}
                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                keyboardType="default"
                onBlur={checkVatNumber}
                onFocus={() => setVatNumberError(false)}
                showHelperText={isVatNumberError}
                helperText="migration_wrong_vat_number_format"
              />}
              <RadioGroup
                options={accountInfo?.accountTypeOptions}
                selected={accountInfo?.selectedAccountType}
                setSelected={accountInfo?.setSelectedAccountType}
                style={styles.radioGroup}
              />
            </Card>
            <VFButton
              type="primary"
              title="migration_account_verify_details"
              onPress={searchAccount}
              style={styles.lastButton}
              disabled={
                accountInfo?.isNextDisabled || isIdError || isEmailError
              }
              isLoading={searchLoading}
              loadingTitle="migration_processing_action"
            />
          </ScrollView>
        </KeyboardAvoidingView>



      )
    }

    if (currentVerificationPageWeb === 2) {
      return (
        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          keyboardVerticalOffset={Platform.OS === 'ios' ? (insets.top + insets.bottom) : 0}
          focusable
          style={styles.container}>
          <ScrollView
            key="3-3"
            contentContainerStyle={styles.scrollContainer(insets.bottom, theme)}
            showsVerticalScrollIndicator={false}>
            <VfText
              size="h3"
              weight="bold"
              style={styles.sectionTitle}
              isLoading={isContentLoading}
              i18nKey="migration_verification_section_title"
            />
            <VfText
              style={styles.textSpacing}
              isLoading={isContentLoading}
              i18nKey="migration_verification_section_info"
            />
            <Card
              shadowLevel="low"
              style={styles.cardStyle}
              contentContainerStyle={styles.cardContentContaoner3}>
              <VFInput
                fieldRef={c => {
                  verifyAccountInfo?.setLastRechargeInput?.(c)
                }}
                label="migration_last_recharges_placeholder"
                value={verifyAccountInfo?.lastRecharge}
                onChangeText={text =>
                  verifyAccountInfo?.setLastRecharge?.(text)
                }
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText}
                style={styles.inputText}
                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                keyboardType="decimal-pad"
                onBlur={saveRechargeValue}
                onFocus={() => setRechargeValueError(false)}
                showHelperText={isRechargeValueError}
                helperText="migration_wrong_last_recharge_format"
              />
              {verifyAccountInfo?.lastRecharges?.map((item, index) => (
                <RowItem
                  key={index}
                  icon={images.money}
                  rightIcon={images.delete}
                  rightIconStyle={{
                    ...styles.verificationRowIcon,
                    ...styles.deleteIcon
                  }}
                  title="migration_last_recharges_currency"
                  titlePlaceholders={[item]}
                  iconStyle={styles.verificationRowIcon}
                  titleStyle={styles.verificationRowText}
                  rightIconPress={() =>
                    verifyAccountInfo?.removeFromLastRecharge?.(index)
                  }
                />
              ))}
              <VFInput
                fieldRef={c => {
                  verifyAccountInfo?.setMostCalledNumberInput?.(c)
                }}
                label="migration_frequently_contacted_placeholder"
                showRightIcon
                rightIconName={images.calendar}
                rightIconType="image"
                rightIconStyle={styles.icon}
                rightIconPress={selectContact}
                value={verifyAccountInfo?.mostCalledNumber}
                onChangeText={text =>
                  verifyAccountInfo?.setMostCalledNumber?.(text)
                }
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText}
                style={styles.inputText}
                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                keyboardType="decimal-pad"
                onBlur={() => saveContact()}
                onFocus={() => setContactError(false)}
                showHelperText={isContactError}
                helperText="migration_wrong_frequently_contacted_format"
              />
              {verifyAccountInfo?.mostCalledNumbers?.map(
                (item, index) => (
                  <RowItem
                    key={index}
                    icon={images.phone}
                    rightIcon={images.delete}
                    rightIconStyle={{
                      ...styles.verificationRowIcon,
                      ...styles.deleteIcon
                    }}
                    title={item}
                    iconStyle={styles.verificationRowIcon}
                    titleStyle={styles.verificationRowText}
                    rightIconPress={() =>
                      verifyAccountInfo?.removeFromMostCalled?.(index)
                    }
                  />
                ),
              )}
            </Card>
            <VfText
              size="h3"
              weight="bold"
              style={styles.sectionTitle}
              isLoading={isContentLoading}
              i18nKey="migration_personal_section_title"
            />
            <VfText
              style={styles.textSpacing}
              isLoading={isContentLoading}
              i18nKey="migration_personal_section_info"
            />
            <Card
              shadowLevel="low"
              style={styles.cardStyle}
              contentContainerStyle={styles.cardContentContaoner3}>
              <VFInput
                label="migration_name_placeholder"
                value={verifyAccountInfo?.name}
                onChangeText={text => verifyAccountInfo?.setName?.(text)}
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText}
                style={styles.inputText}
                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                onBlur={checkName}
                onFocus={() => setNameError(false)}
                showHelperText={isNameError}
                helperText="migration_wrong_name_format"
              />
              <VFInput
                label="migration_surname_placeholder"
                value={verifyAccountInfo?.surname}
                onChangeText={text =>
                  verifyAccountInfo?.setSurname?.(text)
                }
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText}
                style={styles.inputText}
                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                onBlur={checkSurname}
                onFocus={() => setSurnameError(false)}
                showHelperText={isSurnameError}
                helperText="migration_wrong_surname_format"
              />
              <HorizontalLine style={styles.separator} />
              <VFInput
                label="migration_address_placeholder"
                value={verifyAccountInfo?.address}
                onChangeText={text =>
                  verifyAccountInfo?.setAddress?.(text)
                }
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText}
                style={styles.inputText}
                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                onBlur={checkAddress}
                onFocus={() => setAddressError(false)}
                showHelperText={isAddressError}
                helperText="migration_wrong_address_format"
              />
              <VFInput
                label="migration_email_placeholder"
                value={verifyAccountInfo?.emailAddress}
                onChangeText={text =>
                  verifyAccountInfo?.setEmailAddress?.(text)
                }
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText}
                style={styles.inputText}
                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                keyboardType="email-address"
                onBlur={checkEmailAddress}
                onFocus={() => setEmailAddressError(false)}
                showHelperText={isEmailAddressError}
                helperText="migration_wrong_email_format"
              />
              <VFInput
                label="migration_contact_number_placeholder"
                value={verifyAccountInfo?.contactNumber}
                onChangeText={text =>
                  verifyAccountInfo?.setContactNumber?.(text)
                }
                containerStyle={styles.inputContainer}
                labelTextStyle={styles.inputText}
                style={styles.inputText}
                baseColor={isIdError ? theme.colors.textInput.error.tintColor : theme.colors.textInput.default.baseColor}
                textColor={theme.colors.textColor}
                tintColor={theme.colors.textInput.default.tintColor}
                helperTextColor={theme.colors.textInput.error.tintColor}
                keyboardType="decimal-pad"
                onBlur={checkContactNumber}
                onFocus={() => setContactNumberError(false)}
                showHelperText={isContactNumberError}
                helperText="migration_wrong_frequently_contacted_format"
              />
            </Card>
            <VfText
              size="h3"
              weight="bold"
              style={styles.sectionTitle}
              isLoading={isContentLoading}
              i18nKey="migration_id_section_title"
            />
            <VfText
              style={styles.textSpacing}
              isLoading={isContentLoading}
              i18nKey="migration_id_section_info"
            />
            <Card
              shadowLevel="low"
              style={styles.cardStyle}
              contentContainerStyle={styles.cardContentContaoner3}>
              <VfText
                style={styles.textSpacing}
                isLoading={isContentLoading}
                i18nKey="migration_scan_id_info"
              />
              <ImageBackground
                imageStyle={styles.capturedImage}
                source={verifyAccountInfo?.imageFile}
                style={styles.capturedImageContainer}>
                <TouchableOpacity
                  onPress={removePhoto}
                  disabled={verifyAccountInfo?.isRemoveImageDisabled}
                  style={[
                    styles.scannedImageText,
                    {
                      backgroundColor:
                        scannedImageText[
                          `disabled_${verifyAccountInfo?.isRemoveImageDisabled
                          }`
                        ].backgroundColor
                    }
                  ]}>
                  <VfText
                    color={
                      scannedImageText[
                        `disabled_${verifyAccountInfo?.isRemoveImageDisabled
                        }`
                      ].color
                    }
                    style={styles.textSpacing}
                    isLoading={isContentLoading}
                    i18nKey={
                      scannedImageText[
                        `disabled_${verifyAccountInfo?.isRemoveImageDisabled
                        }`
                      ].title
                    }
                  />
                </TouchableOpacity>
              </ImageBackground>
              <VFButton
                type="tertiary"
                title="migration_scan_id"
                onPress={() => setIsCameraOpen(true)}
                style={styles.buttonInCard}
              />
            </Card>
            <VFButton
              type="primary"
              title="migration_verify_details"
              onPress={() => {
                notify(2)
                if (Platform.OS === 'web') {
                  setCurrentPageWeb(3)
                } else {
                  viewpagerRef.current.setPage(2)
                }
                updateProgress(2)
                if (Platform.OS === 'web') {
                  setCurrentVerificationPageWeb(1)
                } else {
                  verificationPagesRef.current.setPage(0)
                }
              }}
              style={styles.lastButton}
              disabled={
                verifyAccountInfo?.isNextDisabled ||
                isRechargeValueError ||
                isContactError ||
                isNameError ||
                isSurnameError ||
                isAddressError ||
                isEmailAddressError ||
                isContactNumberError
              }
            />
          </ScrollView>
        </KeyboardAvoidingView>
      )
    }

    if (currentPageWeb === 3) {
      return (
        <View
          key="3"
          contentContainerStyle={styles.scrollContainerWithSpace(0, theme)}
          showsVerticalScrollIndicator={false}>
          <View>
            <VfText
              size="h3"
              weight="bold"
              style={styles.sectionTitle}
              isLoading={isContentLoading}
              i18nKey="migration_selected_section_title"
            />
            <Collapsible
              items={[
                {
                  icon: images.sim,
                  title: selectedOffer.title || '',
                  desc: selectedOffer.price?.discounted_price?.title || '',
                  content: (
                    <OfferContent
                      isOfferLoading={isOfferLoading}
                      details={selectedOffer.lineItem}
                      iconTypes={iconTypes}
                      isContentLoading={isContentLoading}
                      extraBenefits={selectedOffer.extraBenefits}
                    />
                  ),
                  isLoading: isOfferLoading,
                  card: {
                    shadowLevel: 'low'
                  }
                }
              ]}
              titleStyle={styles.titleStyle(theme)}
              descStyle={styles.titleStyle(theme)}
              withCard
              cardStyle={styles.mySelection}
            />
          </View>
          <View style={styles.summary(insets.bottom, theme)}>
            <VfText
              size="h3"
              weight="bold"
              style={styles.sectionTitle}
              isLoading={isContentLoading}
              i18nKey="migration_summary_section_title"
            />
            <VfText
              style={styles.textSpacing}
              isLoading={isContentLoading}
              i18nKey="migration_summary_section_info"
            />
            <VfText
              size="h3"
              weight="bold"
              style={styles.horizontalSpacing}
              isLoading={isContentLoading}
              i18nKey={selectedOffer.price?.discounted_price?.title || ''}
            />
            <HorizontalLine style={styles.separator} />
            <View style={styles.sumaryDetailsrowContainer}>
              <VfText
                style={styles.textSpacing}
                isLoading={isContentLoading}
                i18nKey="migration_start_date"
              />
              <VfText
                style={styles.textSpacing}
                i18nKey="migration_start_today"
                isLoading={isContentLoading}
                placeHolders={[moment().format('DD/MM/YYYY')]}
              />
            </View>
            {offers?.selectedPeriod !== -1 && (
              <View style={styles.sumaryDetailsrowContainer}>
                <VfText
                  style={styles.textSpacing}
                  isLoading={isContentLoading}
                  i18nKey="migration_contract_duration"
                />
                <VfText
                  style={styles.textSpacing}
                  isLoading={isContentLoading}
                  i18nKey={selectedOffer.activationPeriod?.[offers?.selectedPeriod]?.title || ''}
                />
              </View>
            )}
            <VFButton
              type="primary"
              title="migration_confirm"
              onPress={CreateOrder}
              style={styles.lastButton}
              disabled={confirmationCount >= maxNumOfRetryConfirmation}
              isLoading={orderCreationLoading}
              loadingTitle="migration_processing_action"
            />
          </View>
        </View>
      )
    }

  }

  return (
    <View style={styles.screenWrapper}>
      <StatusBar
        translucent
        barStyle="light-content"
        backgroundColor={
          modalProps.isOpen || infoModal.isOpen
            ? Colors.blackRGBA(0.5)
            : Colors.transparent
        }
        animated
      />
      <Image
        source={images.migrationBackground}
        style={styles.headerBackground}
      />
      <SafeAreaView style={styles.container} edges={['top', 'right', 'left']}>
        {header}
        {timeline()}

        <div style={{
          flex: 1,
          paddingLeft: Dimensions.get('window').width > 700 ? '10%' : 8,
          paddingRight: Dimensions.get('window').width > 700 ? '10%' : 8,
          backgroundColor: theme.colors.backgroundColor
        }}>
          {renderContainer()}
        </div>

        {/* <ViewPager
          key="0"
          ref={viewpager => {
            viewpagerRef.current = viewpager
          }}
          initialPage={0}
          scrollEnabled={false}
          style={styles.viewPager(theme)}>







        </ViewPager> */}

        <Modal
          visible={isCameraOpen}
          close={() => setIsCameraOpen(false)}
          type="full"
          onLayout={event => getModalDimensions(event.nativeEvent.layout)}
          contentContainerStyle={styles.modal}
          insets={insets}>
          {getCamera()}
        </Modal>

        {renderModalInfo()}
        {renderGetTerms()}

        <Modal
          visible={modalProps.isOpen}
          close={() => {
            modalState.back?.()
            closeModal()
          }}
          type={modalProps.type}
          contentContainerStyle={styles.modal}
          insets={insets}>
          {renderModalContent()}
        </Modal>
      </SafeAreaView>
    </View>
  )
}

Migration.defaultProps = {}

Migration.propTypes = {
  isContentLoading: PropTypes.bool,
  detailsLink: PropTypes.string,
  notify: PropTypes.func,
  type: PropTypes.string,
  offers: PropTypes.arrayOf(PropTypes.object),
  existingOrder: PropTypes.bool,
  contractOptions: PropTypes.object,
  termsAndConditions: PropTypes.object,
  accountInfo: PropTypes.object,
  pin: PropTypes.object,
  verifyAccountInfo: PropTypes.object,
  createOrder: PropTypes.func,
  onClose: PropTypes.func,
  maxNumOfRetryConfirmation: PropTypes.number
}

export default Migration
